import axios from "axios";
import { getToken, getRefreshToken } from "../util/localStorage";

const refreshAccessToken = (params = {}) => {
  const token = getToken();
  const refreshToken = getRefreshToken();

  // If no tokens are available, reject immediately
  if (!token || !refreshToken) {
    return Promise.reject(new Error('No tokens available for refresh'));
  }

  let apiVersion = process.env.REACT_APP_API_BASE_URL;  

  const payload = {
    jwtToken: token,
    refreshToken: refreshToken,
  };

  const axiosInstance = axios.create({
    baseURL: apiVersion,
    timeout: 10000,
    headers: { "Content-Type": "application/json" },
  });

  return axiosInstance.post(`/api/User/RefreshToken`, payload);
};

export default refreshAccessToken;
